import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    COMPLETE: 'Application/LOGOUT_COMPLETE',
    DEFAULT: '',
    ERROR: 'Application/LOGOUT_ERROR',
    PENDING: 'Application/LOGOUT_PENDING',
    SUCCESS: 'Application/LOGOUT_SUCCESS'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
